import { render, staticRenderFns } from "./ClientsDetails.vue?vue&type=template&id=5be3e4ae"
import script from "./ClientsDetails.vue?vue&type=script&lang=js"
export * from "./ClientsDetails.vue?vue&type=script&lang=js"
import style0 from "./ClientsDetails.vue?vue&type=style&index=0&id=5be3e4ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports